import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./InviteFriendModal.css";
import { IoClose } from "react-icons/io5";
import { IoCopyOutline } from "react-icons/io5";
import { RiWhatsappFill } from "react-icons/ri";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const InviteFriendModal = ({ isOpen, onClose, }) => {
    const userData = JSON.parse(localStorage.getItem("userData")) || null;
    const navigate = useNavigate();

    const shareText = `Hey Partygoer 👋

*${userData?.name}* has invited you to join Partywitty Network! 🎉

✨ Use *referral code ${userData?.referral_code}* while signing up and get 500 Carrots (worth ₹500) instantly. You can use these as your booking amount for any party! 🥳

And when you book, *${userData?.name}* also earns up to 200 Carrots as an invite bonus. Win-win! 💜

More friends = More Carrots = More Parties

👉 https://partywitty.com/login`;

    const showText = `Party hard, earn harder! 

Refer your friends to PartyWitty & get up to 200 Carrots 🥕 on their first booking! ✅

Use my code 👉 ${userData?.referral_code} 

 More friends = More Carrots = More Parties!`;




    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        const textToCopy = `${shareText}`;
        navigator.clipboard.writeText(textToCopy).then(() => {
            setCopied(true);

            // Reset copied state after 2 sec
            setTimeout(() => setCopied(false), 2000);
        });
    };

    // useEffect(() => {
    //     if (!userData) {
    //         navigate("/login");
    //     }
    // }, [userData]);



    if (!isOpen) return null;
    return createPortal(
        
        <div className={`InviteFriendModel-overlay ${isOpen ? "active" : ""}`}>
            <div className="InviteFriendModel-container">
                <button className="InviteFriendModel-closeBtn" onClick={onClose}><IoClose /></button>
                <h2 className="InviteFriendModel-heading">Sharing Text</h2>
                <div className="InviteFriendModel-text">
                    <p>{showText}</p>
                    <div className="InviteFriendModel-copy-wrapper">
                        <button
                            className="InviteFriendModel-copyBtn"
                            onClick={handleCopy}
                        >
                            <IoCopyOutline style={{ marginRight: "6px" }} />
                        </button>
                        <span className="InviteFriendModel-copyText">
                            {copied ? "Copied!" : ""}
                        </span>
                    </div>
                </div>

                <div className="InviteFriendModel-divider"></div>
                <div className="InviteFriendModel-socialButtons">
                    <a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`} target="_blank" rel="noopener noreferrer" className="InviteFriendModel-socialBtn InviteFriendModel-whatsapp"><RiWhatsappFill color="#00E676" /> WhatsApp</a>
                    <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`} target="_blank" rel="noopener noreferrer" className="InviteFriendModel-socialBtn InviteFriendModel-twitter"><FaSquareXTwitter color="#000000" /> Twitter</a>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=https://partywitty.com&quote=${encodeURIComponent(shareText)}`} target="_blank" rel="noopener noreferrer" className="InviteFriendModel-socialBtn InviteFriendModel-facebook"><FaFacebook color="#039BE5" /> Facebook</a>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default InviteFriendModal;
